import { ArrowUpRight, MapPin } from "lucide-react";

export const ServerCard = ({ server, index }) => (
  <a
    href={server.url}
    data-testid={`select-${server.id}-button`}
    className="dz-card group relative flex flex-col overflow-hidden border border-white/10 bg-[#121314] dz-fade"
    style={{ "--accent": server.accent, animationDelay: `${150 + index * 150}ms` }}
  >
    <div className="relative aspect-video overflow-hidden">
      <img
        src={server.image}
        alt={`Banner ${server.name}`}
        data-testid={`server-banner-${server.id}`}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
      />
      <span className="dz-corner dz-corner-tl" />
    </div>
    <span className="dz-corner dz-corner-br" />
    <div className="flex flex-col flex-1 p-6 sm:p-8">
      <div className="flex items-center justify-between dz-mono text-xs uppercase tracking-[0.25em] text-zinc-400 mb-5">
        <span>Servidor 0{index + 1}</span>
        <span className="flex items-center gap-1.5 text-[#f87171]">
          <MapPin size={13} /> {server.tagline}
        </span>
      </div>
      <h2
        className="dz-heading text-3xl sm:text-4xl font-black uppercase leading-none text-white"
        data-testid={`server-name-${server.id}`}
      >
        {server.name}
      </h2>
      <p className="mt-3 text-sm sm:text-base text-zinc-400 max-w-md leading-relaxed flex-1">{server.description}</p>
      <span
        className="dz-play mt-7 self-start inline-flex items-center gap-3 px-7 py-4 dz-heading text-lg font-extrabold uppercase tracking-wider text-white"
        style={{ background: server.accent }}
      >
        Jogar agora
        <ArrowUpRight size={20} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
      </span>
    </div>
  </a>
);
